import React from "react";
import { api } from "../api";
let inflight;
function load() {
  if (!inflight) inflight = Promise.resolve().then(() => api.get("/business-status")).then(({ data }) => data || {}).catch(() => ({})).finally(() => { inflight = null; });
  return inflight;
}
export function useBusinessStatus() {
  const [status, setStatus] = React.useState({});
  React.useEffect(() => {
    let active = true;
    const refresh = () => load().then((next) => { if (active) setStatus(next); });
    refresh();
    window.addEventListener("focus", refresh);
    const timer = window.setInterval(refresh, 60000);
    return () => { active = false; window.removeEventListener("focus", refresh); window.clearInterval(timer); };
  }, []);
  return status;
}
